import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TermsStudentPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // 履歴があるかチェックして、なければチャットページに戻る
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/chat');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        py: { xs: 2, sm: 4, md: 6 },
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleBack}
            sx={{
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            戻る
          </Button>
        </Box>

        <Paper
          elevation={8}
          sx={{
            p: { xs: 3, sm: 4, md: 6 },
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
          }}
        >
          {/* Title */}
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              textAlign: 'center',
              mb: 4,
              background: 'linear-gradient(45deg, #667eea, #764ba2)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent',
            }}
          >
            学生向け利用規約
          </Typography>

          {/* Company Information */}
          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              会社名：株式会社Gerbera
            </Typography>
            <Typography variant="body1" color="text.secondary">
              代表取締役：𠮷岡 歩真
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          {/* Introduction */}
          <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
            株式会社Gerbera（以下「弊社」といいます）は、当社が運営するサービス「ガクフドキャリア」（以下「本サービス」といいます）の利用に際し、以下の利用規約（以下「本規約」といいます）を定めます。
          </Typography>

          {/* Terms Items */}
          <List sx={{ mb: 4 }}>
            {/* 第1条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第1条（適用）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    本規約は、本サービスのご利用にあたっての条件及びご利用に関する条件を定めており、弊社と後記の利用者及び仮登録者との間の本サービスの利用に関わる一切の関係に適用されます。ただし、本サービスに関連する弊社の個別サービス等に関し本規約の内容と異なる内容を別途定めた場合は、その規定が優先されます。
                  </Typography>
                }
              />
            </ListItem>

            {/* 第2条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第2条（定義）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　「本サービス」とは、弊社が運営するWebサイト（弊社Webサイトのドメイン又は内容が変更された場合は、当該変更後のWebサイトを含みます）及びスマートフォン向けアプリ等で提供する「ガクフドキャリア」において弊社が提供する学生向け就職活動支援サービスの総称（サービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます）をいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　「利用者」とは、第３条第１項に定める要件を満たし、本条第６項の利用者登録をした者をいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ３　「利用希望者」とは、本サービスを利用するため、利用者となることを希望する者をいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ４　「利用企業」とは、弊社の審査を経て、弊社が提供する本サービスを通じて自社の新卒採用のために利用者と接触することを承認した企業（同サービスのトライアルを利用している企業も含みます）をいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ５　「仮登録」とは、利用希望者が、本規約に同意の上、弊社ホームページ上の新規ユーザー登録画面において、弊社所定の情報（以下本条第６項において利用希望者が入力する弊社所定の情報と併せて「登録情報」といい、登録情報に含まれるメールアドレスを「登録アドレス」といいます）を入力の上、登録ボタンをクリックすることで本契約を締結することをいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ６　「利用者登録」とは、前項の仮登録をした利用希望者（以下「仮登録者」といいます）が、弊社から登録アドレス宛に送られるメールの記載に従い本人確認手続き（以下「認証手続き」といいます）を行い、かつ、認証手続き後に、仮登録者が、自らの意思で弊社所定の登録情報を本サービスに登録することをいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ７　「オファー」とは、利用企業が採用基準を満たす可能性があるものと判断した利用者に対し、本サービスを用いて説明会や面接等の案内を送付することをいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ８　「既卒者」とは、大学・大学院・短期大学・高等専門学校・専修学校及び各種学校（海外の大学等を含みます）を卒業し、又はその卒業予定年月を経過した者をいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ９　「本検査」とは、弊社が本サービス内で提供する適性検査をいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １０　「マッチング等分析」とは、弊社が利用企業からの委託によって、登録情報及び本検査の結果と利用企業から同意のうえ提供を受けた情報等から、利用企業と学生のマッチング等の分析を行うことをいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １１　「マイページ」とは、プロフィール登録やオファーの状況の閲覧、本検査の受検及びその結果の閲覧等をするために弊社が設置する利用者及び仮登録者（以下「利用者等」といいます）ごとのウェブページをいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １２　「ID等」とは、利用者等が本サービスの利用に際して用いるID及びパスワードであって、当該利用者等のマイページにログインするために必要なものをいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １３　「利用者情報」とは、登録情報、本検査の受検結果、その他本サービス利用に関し弊社（弊社サイト内におけるアクセス履歴を含む）及び利用企業が取得した利用者に関する情報をいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １４　「登録可能時期」とは、弊社所定の学生が本サービスの仮登録及び利用者登録を行うことが可能となる時期をいいます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      １５　前各号のほか、本規約においては、別途個人情報保護法に定義のある用語は、その例によります。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第3条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第3条（利用者登録及び利用者の責任）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　利用者登録を行う者は、次の各号の要件をすべて満たす必要があります。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （1）大学・大学院・短期大学・高等専門学校・専修学校及び各種学校（海外の大学等を含みます）に在籍する学生であること。ただし、卒業予定年月より前に卒業した者は、利用者登録ができるものとします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （2）利用者登録以前に職歴（起業又はアルバイトであって、在学中のものは除く）がないこと。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　利用希望者は、仮登録を行うものとします。仮登録者は、仮登録後速やかに利用者登録を完了しなければなりません。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ３　弊社は、仮登録者に対し認証手続きを行い、仮登録者は、利用者登録が完了したときに、利用者たる地位を取得するものとします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ４　前項の利用者登録が完了したときは、当該利用者のマイページは利用企業に対し自動的に公開され、オファーを受けることができる状態となることに、あらかじめ同意します。ただし、利用者はマイページをいつでも非公開に変更し、又は、マイページの内容を変更・修正することができます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ５　利用者等は、責任をもって本サービスを利用し、登録情報が常に自己の最新かつ正確な情報であるように変更・追加・削除するとともに、自らの責任において登録情報を管理します。なお、本検査の受検結果は変更・追加・修正できません。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ６　利用者は、オファーを承諾した企業から直接メッセージ、電話又はメール等による連絡を受け取る場合があることにあらかじめ同意します。なお、利用企業はオファー送信等の採用活動を第三者に委託することがあります。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ７　利用者等は、弊社が別途定める「個人情報保護方針」及び「プライバシーポリシー」に従い利用者等の個人情報を取り扱うことに同意します。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ８　弊社は、利用希望者が次の一にでも該当すると判断した場合には仮登録及び利用者登録を承諾しないものとし、それにより利用希望者に生じた不利益及び損害について一切の責任を負いません。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１）虚偽の登録情報を入力・送信した場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （２）既卒者であった場合又は登録可能時期ではない場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （３）利用希望者が過去に本規約に違反したことがある者の場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （４）利用希望者が高校生（高等専門学生は除く）以下の場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （５）第１５条各項の一にでも該当する事由がある場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （６）利用希望者が本サービスを悪用するおそれがあると弊社が判断した場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, pl: 2 }}>
                      （７）その他、弊社が本サービスの利用を相当でないと判断した場合。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第4条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第4条（本サービスの利用）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　弊社は、利用者に対し、本規約に従い本サービスを日本国内において非独占的に利用することを許諾します。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　利用者は本サービスを無料で利用することができます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ３　本サービスの利用に要する機器、通信費用等は、すべて利用者等の負担とします。弊社は利用者等の使用する機器等が本サービスに適合するものであることを保証するものではありません。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ４　利用者等は、本サービスに関するお問い合わせへの対応など、利用者等における本サービス利用の利便性向上等のため、弊社が本サービスのご利用状況（本サービス内における利用企業とのメッセージを含む）を確認する場合があることに同意します。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ５　弊社は、本規約又は本サービスの内容、利用条件の変更、休止又は廃止等を自由に行うことができるものとします。これらの変更等を行う場合は、マイページ又は電子メール等によって事前に掲載・通知をし、当該変更等の内容は、弊社がマイページに掲載後、利用者等が本サービスの利用を終了しない場合、１４日後に効力を生じるものとします。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第5条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第5条（本サービス利用の終了）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　利用者等は、既卒者となった後は、本サービスを利用できなくなることにあらかじめ同意します。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ２　弊社は、利用者等が卒業予定年月を経過したにもかかわらず、ID等又はマイページを利用していることを発見した場合、当該利用者等に通知することなくID等及びマイページを削除できます。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第6条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第6条（ID等の管理等）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　利用者等は、ID等を自己の責任において適切に管理し、登録情報の内容が最新となるよう利用者等で適宜修正する義務を負います。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　利用者等は、いかなる場合にも、ID等を第三者に利用させ、又は貸与、譲渡、名義変更、売買等をしてはなりません。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ３　弊社は、IDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのID等を登録している利用者等による利用とみなし、これに基づき弊社又は第三者に生じた損害はすべて、そのID等を保有する利用者等が負担するものとします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ４　利用者等は、ID等が不正に利用されていることを知った場合には、直ちにその旨を弊社に連絡するものとします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ５　ID等以外の登録情報に変更があったときは、利用者等は速やかにマイページを用いて変更手続きを行うものとし、登録情報に不正確な点があることが判明した場合も同様とします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ６　登録アドレスに変更があったときは、変更手続き完了前に弊社が変更前の登録アドレス宛に送付したメールは、有効に利用者等に送付されたものとみなします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ７　利用者等は、ID等の盗難・紛失・不正使用・第三者による無断使用等によって生じた損害に関する一切の責任を負い、弊社はこれに関して一切の責任を負いません。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第7条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第7条（個人情報）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　弊社は利用者情報を、「個人情報保護方針」及び「プライバシーポリシー」に記載の利用目的の範囲内で利用いたします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　利用者は、自己の利用者情報が利用企業に提供されることについて、本規約をもって同意します。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ３　弊社は、利用者情報を個人情報ではなく統計情報又は匿名加工情報として利用者の同意なしに利用・提供することがあります。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ４　弊社が利用企業からの委託によってマッチング等分析を行った場合、その分析結果については、当該利用企業の営業秘密であり、かつ、利用企業の従業員の個人情報を含むものであるため、当該利用企業との関係で守秘義務の対象となっており弊社に開示権限がないので、利用者からの開示請求に応じることができません。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ５　利用者は、弊社が、マッチング率の向上等のサービス向上のための追跡調査等を目的として、利用者の卒業予年月の翌月から３年間、当該利用者の利用者情報を保有し、利用できることについて、本規約をもって同意するものとします。なお、弊社は、利用者の卒業予年月の翌月から３年を超える利用者情報については、個人情報ではなく統計情報又は匿名加工情報にして、分析のために保有します。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第8条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第8条（禁止事項）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　利用者等は、本サービスの利用にあたり、次の各号の行為をしてはなりません。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１）本規約に違反する行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （２）虚偽又は第三者の情報など不適切な情報を登録する行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （３）弊社又は第三者の権利を侵害するおそれのある行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （４）他の利用者等のID等を取得・利用し、又は第三者にID等を開示する行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （５）本サービスの運営を妨げる行為、弊社の信用若しくは名誉を毀損する行為又はそのおそれのある行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （６）本サービス上での宣伝、広告、勧誘又は営業行為その他本サービスの利用目的に反する行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （７）日本国又はご利用の際に利用者が所在する国・地域の法令、社会規範又は公序良俗に反する行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （８）重複して仮登録又は利用者登録する行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （９）利用者等の自己PRのための目的以外でURLをマイページに掲載する行為（ただし、弊社が別途掲載を許可している場合は除く）。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１０）自己のメールアドレス、電話番号又はSNSアカウント等を、マイページに掲載する行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１１）オファーを承諾し選考が継続している場合に、当該オファー承諾を取り消す行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１２）他の利用者等の個人情報及びその他本サービスに登録されている情報を当該利用者等に無断で収集したり蓄積したりする行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１３）その他弊社が不適切と判断する行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ２　弊社は、利用者等の同意を得ることなく、マイページにおける前項の禁止事項の遵守状況を確認することがあります。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第9条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第９条（登録抹消・再登録の拒否等）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　弊社は、利用者等が本規約に違反し、又は本サービスの利用が適当でないと判断した場合、何らの通知することなく、直ちに本サービスの利用を停止し、利用者情報の削除、利用者登録及び仮登録の抹消又は再登録を拒否できます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　弊社は、利用者等が本サービスに重複登録していることを発見した場合、重複する登録情報及びマイページのうち、いずれかを、利用者等に通知することなく削除できます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ３　弊社は、面接その他イベントの参加状況等に関する弊社からの問い合わせに対して利用者等が３０日間以上応答しない場合、何らの通知を要せず、本サービスの利用を停止できます。なお、弊社からのこれらの問い合わせは、メール、電話又はマイページに掲載すること等によって行います。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ４　弊社は、前各項の規定により利用者等に生じた不利益及び損害について一切の責任を負いません。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第10条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１０条（活動終了による退会等）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　利用者等は、就職活動を終了した場合又は既卒者となった場合には、本サービスを退会する必要があります。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　弊社は、前項にかかわらず、利用者等の卒業予定年度の３月３１日から半年以上経過したときは、何らの通知を要せず、本サービスの利用を停止できるものとし、３年以上経過したときは、何らの通知を要せず、登録情報、利用者情報、仮登録及び利用者登録を抹消でき、弊社はこれにより生じた不利益及び損害について一切の責任を負いません。ただし、卒業予定年度に変更があった場合は、本サービスの再登録ができるものとします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ３　前各項の規定により退会又は登録抹消された場合、再度本サービスの利用を希望する場合であっても、退会又は登録抹消前の登録情報、利用者情報及びID等は利用できません。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第11条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１１条（同意事項）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      利用者等は弊社に対し、次の各号の事項について同意する。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１）本サービスを利用して、利用者等が利用企業に対して提供した情報及び利用企業から提供された情報を、弊社が閲覧すること
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （２）弊社が電子メール、郵便、電話又はファックス等の手段を用いて連絡すること
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, pl: 2 }}>
                      （３）弊社が、本サービスの提供に際して、本契約の義務と同様の義務を負わせる等必要な措置を講じた上で、その一部を弊社と契約する第三者に業務委託する場合があること
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第12条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１２条（本サービスの停止）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　弊社は次の各号に定める事項が生じた場合は、自らの判断により利用者等に対する本サービスの全部又は一部を中断することができます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１）天災地変、戦争、暴動、公権力による命令処分等不可抗力が発生し又は発生しうると予見される場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （２）弊社の管理する設備若しくはシステムの保守を定期的に又は緊急に行う場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （３）弊社の管理する設備若しくはシステムの障害その他やむを得ない事由が生じた場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　弊社は、前項の規定により本サービスを中断する場合、弊社が適当と判断する方法で事前に利用者等及び利用企業にその旨を通知又は弊社のホームページ上に掲示します。ただし、かかる本サービスの中断が緊急に必要な場合、又はやむを得ない事情により通知できない場合には、この限りではありません。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ３　弊社は、本条第１項により本サービスを中断したことによって利用者等に生じた損害を賠償する責任を負わないものとし、利用者等はこれをあらかじめ承諾するものとします。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第13条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１３条（本サービスの仕様変更）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    弊社は、利用者等及び利用企業の利便性の改善やバグの修正等を目的として、利用者等に対して事前に通知することなく、本サービスのシステム仕様等を変更することがあります。
                  </Typography>
                }
              />
            </ListItem>

            {/* 第14条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１４条（保証の否認及び免責）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　利用者等は、本サービスが利用者の特定の目的に適合すること、期待する機能・正確性・確実性・有用性を有すること及びシステム上の不具合が生じないことに関して弊社は何ら保証するものではないことをあらかじめ了承の上、自己の責任において利用します。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　利用者等は、本サービスにおいて提供される情報（企業の採用情報、メッセージ送受信機能により提供された情報等を含みます）に関して弊社は何ら保証するものではないことをあらかじめ了承の上、自己の責任において利用します。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ３　弊社は、弊社の故意又は重過失によらない場合、利用者等に対する責任は免責されるものとします。弊社の故意又は重過失に起因する場合でも、弊社は通常生じうる損害の範囲内で損害賠償責任を負うものとします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ４　弊社は、本サービスの利用に関連して利用者等と他の利用者等又は第三者との間において生じた取引、連絡、紛争等について、弊社の故意又は重過失に起因する場合を除き、一切の責任を負いません。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第15条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１５条（反社会的勢力との取引排除）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　弊社及び利用者等は、それぞれ相手方に対し、次の各号の事項を確約するものとします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１）自らが、暴力団、暴力団員、暴力団員でなくなったときから５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他これらに準ずる者（以下総称して「反社会的勢力」といいます）ではないこと。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （２）反社会的勢力に自己の名義を利用させ、本契約を締結するものでないこと。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （３）自ら又は第三者を利用して、本契約に関して次の行為をしないこと。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 4 }}>
                      （ａ）相手方に対する脅迫的な言動又は暴力を用いる行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 4 }}>
                      （ｂ）偽計又は威力を用いて相手方の業務を妨害し、又は信用を毀損する行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 4 }}>
                      （ｃ）法的な責任を超えた不当な要求行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 4 }}>
                      （ｄ）その他前各号に準ずる行為。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ２　当事者の一方が次の各号の一に該当した場合には、その相手方は、何らの通知、催告を要せず、直ちに本契約を解除することができます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１）前項（１）の確約に反する表明をしたことが判明した場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （２）前項（２）の確約に反し契約をしたことが判明した場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （３）前項（３）の確約に反した行為をした場合。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      ３　前項の規定により本契約が解除された場合には、解除された者は、その相手方に対し、相手方の被った損害を賠償するものとします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ４　本条第２項の規定により本契約が解除された場合には、解除された者は、解除により生じる損害について、その相手方に対し一切の請求を行わないものとします。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第16条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１６条（知的財産保護）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      １　弊社及び利用者等は、本サービスを通じて相手方から提供を受けた著作物その他の知的財産について、本サービスの利用のためにのみ使用を許諾されるものとし、相手方の事前の書面による承諾を得ることなく他の目的で使用、複製、転写、又は頒布することはできないものとします。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ２　弊社及び利用者等は、本サービスの利用が終了した場合、前項の知的財産について、速やかに相手方の指示に従い、相手方に返還、安全な方法による廃棄処分又は相手方からデータファイル形式により相手方の知的財産を受領している場合は、当該データを速やかに消去するものとします。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第17条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１７条（権利義務譲渡の禁止）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    弊社の事前の書面による承諾を得ることなく、利用者等が本規約に基づく一切の権利義務を第三者に譲渡若しくは貸与し又は担保に供することはできません。
                  </Typography>
                }
              />
            </ListItem>

            {/* 第18条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１８条（損害賠償）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    弊社及び利用者等は、本規約に違反して相手方に損害を与えた場合、当該損害が生じた原因が自己の故意又は重過失によるものである場合は、相手方に対し、その損害を賠償する責任を負います。
                  </Typography>
                }
              />
            </ListItem>

            {/* 第19条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第１９条（契約解除）
                  </Typography>
                }
                secondary={
                  <Box>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1 }}>
                      弊社及び利用者等は、相手方が次の各号の一に該当したときは、何らの通知、催告を要せず、直ちに本契約を解除することができます。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （１）本規約等に定める条項に違反し、相手方に対しその是正を催告したにもかかわらず、１４日以内に当該違反が是正されないとき。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （２）重大な過失又は背信行為があったとき。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （３）監督官庁より営業の許可取消し、停止等の処分を受けたとき。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （４）支払停止若しくは支払不能の状態に陥ったとき、又は手形若しくは小切手が不渡りとなったとき。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （５）第三者より差押え、仮差押え、仮処分若しくは競売の申立て、又は公租公課の滞納処分を受けたとき。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （６）破産、民事再生、会社更生又は特別清算手続開始の申立てがあったとき。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （７）解散、会社分割、事業譲渡又は合併の決議をしたとき。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （８）資産又は信用状態に重大な変化が生じ、本規約等に基づく債務の履行が困難になるおそれがあると認められるとき。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1, pl: 2 }}>
                      （９）その他前各号に準ずるような本契約を継続し難い重大な事由が発生したとき。
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                      ２　前項の場合、本契約を解除された当事者は、解除によって解除をした当事者が被った損害の一切を賠償するものとします。
                    </Typography>
                  </Box>
                }
              />
            </ListItem>

            {/* 第20条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第２０条（合意管轄）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    本規約に関して紛争が生じた場合、訴額に応じ、大阪簡易裁判所又は大阪地方裁判所を第一審の専属的合意管轄裁判所とします。
                  </Typography>
                }
              />
            </ListItem>

            {/* 第21条 */}
            <ListItem sx={{ alignItems: 'flex-start', px: 0 }}>
              <ListItemText
                primary={
                  <Typography variant="h6" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
                    第２１条（協議事項）
                  </Typography>
                }
                secondary={
                  <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                    本規約に定めのない事項及び本規約の解釈に疑義が生じたときは、両当事者間で誠実に協議の上、これを解決します。
                  </Typography>
                }
              />
            </ListItem>
          </List>

          <Divider sx={{ mb: 4 }} />

          {/* Contact Information */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" component="div" sx={{ mb: 2, fontWeight: 'bold' }}>
              お問い合わせ先
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              電話番号：06-7176-5480
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              FAX番号：06-7635-8254
            </Typography>
            <Typography variant="body1">
              E-mail：info@gakufudo-career.jp
            </Typography>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Footer */}
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="body2" color="text.secondary">
              以上
            </Typography>
          </Box>
        </Paper>

        {/* Bottom Footer */}
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography 
            variant="body2" 
            color="white" 
            sx={{ opacity: 0.8 }}
          >
            © {new Date().getFullYear()} 株式会社Gerbera. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsStudentPage;